/* import __COLOCATED_TEMPLATE__ from './attachment-list.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();